import { createContext } from 'react';

import { SourceEnum } from 'js/src/client';
import { EDITOR_TAB_OPTIONS } from 'js/src/data/app';
import type { UploadSearchContextType } from 'js/src/data/media';
import { SEARCH_CONTEXT } from 'js/src/data/media';

export type TEditorTabsContext = {
    editorTab: null | EDITOR_TAB_OPTIONS;
};

export const EditorTabsContext = createContext<TEditorTabsContext>({
    editorTab: null,
});

export const EditorTabsContextProvider = EditorTabsContext.Provider;
export const EditorTabsContextConsumer = EditorTabsContext.Consumer;

export function getUploadSourceFromContext(editorTab: EDITOR_TAB_OPTIONS, isIcon: boolean) {
    switch (editorTab) {
        case EDITOR_TAB_OPTIONS.VOICEOVER:
            return SourceEnum.SOURCE_USER_VOICEOVER;
        case EDITOR_TAB_OPTIONS.ELEMENTS:
            if (isIcon) {
                return SourceEnum.SOURCE_USER;
            }
            return SourceEnum.SOURCE_USER_STICKERS;
        default:
            return SourceEnum.SOURCE_USER;
    }
}

export function getUploadSearchContextFromEditorTabContext(
    editorTab: EDITOR_TAB_OPTIONS | null,
): UploadSearchContextType {
    switch (editorTab) {
        case EDITOR_TAB_OPTIONS.MEDIA:
            return SEARCH_CONTEXT.UPLOADED_VISUALS;
        case EDITOR_TAB_OPTIONS.MUSIC:
            return SEARCH_CONTEXT.UPLOADED_AUDIO;
        case EDITOR_TAB_OPTIONS.ELEMENTS:
            return SEARCH_CONTEXT.UPLOADED_ELEMENTS;
        case EDITOR_TAB_OPTIONS.VOICEOVER:
            return SEARCH_CONTEXT.UPLOADED_VOICEOVERS;
        default:
            throw Error('Editor tab does not support upload');
    }
}
